<template>
  <b-table-simple
    bordered
    small
    :responsive="false"
    class="mapping-table"
    :class="{ 'mapping-table--compact': compact }"
  >
    <b-thead head-variant="light">
      <b-tr>
        <b-th v-if="showColumn">Show</b-th>
        <b-th v-if="showRequiredColumn">Required</b-th>
        <b-th>
          <MappingSortableHeader
            field="columnName"
            :sort-state="sortState"
            @sort-toggle="onSortToggle"
          >
            SQL expression
          </MappingSortableHeader>
        </b-th>
        <b-th>
          <MappingSortableHeader
            field="displayName"
            :sort-state="sortState"
            @sort-toggle="onSortToggle"
          >
            Display name
          </MappingSortableHeader>
        </b-th>
        <b-th v-if="showFilterColumn" class="text-center">Filter</b-th>
        <b-th>Type</b-th>
        <b-th>Graph</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-if="!rows.length">
        <b-td :colspan="sqlColspan" class="text-center text-muted small py-3">
          <slot name="empty">No columns parsed from SQL.</slot>
        </b-td>
      </b-tr>
      <b-tr
        v-for="row in rows"
        :key="'sqlmap-' + row.required + '-' + row.expr"
      >
        <b-td v-if="showColumn" class="text-center align-middle">
          <b-form-checkbox
            :checked="row.show"
            size="sm"
            class="mb-0"
            :aria-label="'Show ' + (row.label || row.expr)"
            @change="(v) => onFieldChange(row, 'show', v)"
          />
        </b-td>
        <b-td v-if="showRequiredColumn" class="align-middle">{{ row.required }}</b-td>
        <b-td class="align-middle">
          <code
            class="column-name-readonly column-name-readonly--inline tblbar-expr-code"
            :title="row.expr"
            >{{ row.expr }}</code
          >
        </b-td>
        <b-td class="align-middle">
          <input
            :value="row.label"
            class="inline-mapping-input"
            placeholder="Business / header name"
            @input="(e) => onFieldChange(row, 'label', e.target.value)"
          />
        </b-td>
        <b-td v-if="showFilterColumn" class="text-center align-middle">
          <b-form-checkbox
            :checked="row.filterable"
            size="sm"
            class="mb-0"
            @change="(v) => onFieldChange(row, 'filterable', v)"
          />
        </b-td>
        <b-td class="align-middle">
          <b-form-select
            :value="row.type"
            :options="typeOptions"
            size="sm"
            class="type-select"
            @change="(v) => onFieldChange(row, 'type', v)"
          />
        </b-td>
        <b-td class="align-middle">
          <b-form-select
            :value="row.graph"
            :options="graphOptions"
            size="sm"
            class="type-select"
            :disabled="row.type !== 'Metric'"
            @change="(v) => onFieldChange(row, 'graph', v)"
          />
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import {
  TABLE_BAR_TYPE_OPTIONS,
  TABLE_BAR_GRAPH_OPTIONS,
} from "@/common/columnMappingConstants";
import MappingSortableHeader from "./MappingSortableHeader.vue";

export default {
  name: "SqlVariableMappingTable",
  components: { MappingSortableHeader },
  props: {
    rows: { type: Array, default: () => [] },
    /** VizletHeader: show visibility checkbox */
    showColumn: { type: Boolean, default: false },
    showRequiredColumn: { type: Boolean, default: true },
    showFilterColumn: { type: Boolean, default: true },
    sortState: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  computed: {
    sqlColspan() {
      let n = 4;
      if (this.showColumn) n += 1;
      if (this.showRequiredColumn) n += 1;
      if (this.showFilterColumn) n += 1;
      return n;
    },
  },
  data() {
    return {
      typeOptions: TABLE_BAR_TYPE_OPTIONS,
      graphOptions: TABLE_BAR_GRAPH_OPTIONS,
    };
  },
  methods: {
    onFieldChange(row, field, value) {
      this.$emit("row-change", { row, field, value });
    },
    onSortToggle(field) {
      this.$emit("sort-toggle", field);
    },
  },
};
</script>
